import {
  Button,
  Card,
  makeStyles,
  Fade,
  TextField,
  Typography,
  MuiThemeProvider,
  createMuiTheme,
  InputAdornment,
} from "@material-ui/core";
import React, { useState } from "react";
import NavDrawer from "./NavDrawer";
import ReportProblemRoundedIcon from "@material-ui/icons/ReportProblemRounded";
import axios from "axios";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    paddingTop: theme.spacing(6),
  },
  main: {
    display: "flex",
    flexWrap: "wrap",
    margin: `${theme.spacing(0)} auto`,
    paddingTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    justifyContent: "space-around",
    flexDirection: "column",
    width: "auto",
  },
  addUserTitle: {
    fontSize: 30,
    padding: theme.spacing(1),
    fontVariant: "small-caps",
    fontWeight: 900,
    letterSpacing: "2px",
    borderBottom: "2px solid #365680",
    width: "100%",
    color: "#365680",
    display: "flex",
    justifyContent: "flex-start",
  },
  addUserBtn: {
    backgroundColor: "#FF6B00",
    color: "#FFF",
    textTransform: "none !Important",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#365680",
    },
    marginTop: theme.spacing(2),
    width: "100%",
    letterSpacing: 2,
  },
  addUser: {
    // padding: theme.spacing(1),
    color: "#365680 !important",
    marginBottom: theme.spacing(2),
    width: "100%",
    letterSpacing: "2px",
  },
  addUserInput: {
    color: "#365680 !important",
    letterSpacing: "2px",
  },
  textFieldUnderline: {
    "&:before": {
      borderBottomColor: "#FF6B00",
    },
    "&:after": {
      borderBottomColor: "#FF6B00",
    },
    "&:hover:before": {
      borderBottomColor: "#FF6B00 !important",
    },
  },
  form: {
    width: 320,
    justifyContent: "center",
    alignItems: "center",
    background: "#F1F1F1",
    borderRadius: 12,
    marginTop: 24,
    display: "flex",
    flexDirection: "column",
  },
  card: {
    background: "#F1F1F1",
    padding: theme.spacing(6),
  },
  errorSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    padding: "20px 0px 0px 0px",
  },
  errorMessage: {
    textAlign: "center",
    fontSize: 14,
    fontWeight: "600",
    color: "red",
  },
  errorIcon: {
    color: "red",
    margin: "0px 10px 0px 0px",
  },
  fieldIcons: {
    height: 24,
    width: 24,
    cursor: "none",
    pointerEvents: "none",
    color: "#FF6B00",
  },
}));
const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MuiInputLabel: {
        shrink: {
          color: "#FF6B00",
        },
      },
      MuiFormLabel: {
        root: {
          color: "#365780",
          "&.Mui-focused": {
            color: "#FF6B00",
          },
        },
      },
    },
  });

const AddUser = () => {
  const classes = useStyles();
  const history = useHistory();
  const [error, setError] = useState(null);
  const [emailValid, setEmailValid] = useState(true);
  const [showEmailValidity, setShowEmailValidity] = useState(false);

  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "P@55word",
    error: "",
  });

  const emailValue = (e) => {
    let trimmedValue = e.target.value.trim();
    setUser({ ...user, email: trimmedValue });
    // console.log(trimmedValue);
    const validateEmail = (email) => {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    };

    if (validateEmail(trimmedValue) === true && trimmedValue !== "") {
      // console.log("trueeeee");

      setEmailValid(true);
    } else {
      // console.log("falseeeeeeeee");

      setEmailValid(false);
    }
  };

  const handleNewUser = async () => {
    if (
      user.firstName !== "" ||
      user.lastName !== "" ||
      user.email !== "" ||
      user.password !== ""
    ) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BASE_URL}api/users/adduser`,
          user
        );
        console.log(response);

        switch (response.status) {
          case 201:
            console.log("User Added");
            alert("Admin added successfully.");
            history.push("/users");
            break;
          case 409:
            alert(response.data.errors);
            break;
          case 500:
            alert(response);
            break;
          case 400:
            alert(response);
            break;
          case 202:
            alert(response);
            break;
          default:
            break;
        }
      } catch (error) {
        console.log(error.response);
        const errorMessage = error;
        alert(errorMessage);
      }
    } else {
      console.log("Fields must be filled");
      setError(true);
    }
  };

  return (
    <>
      <div className={classes.root}>
        <NavDrawer />
        <div className={classes.main}>
          <Card className={classes.card} elevation={0}>
            <MuiThemeProvider theme={getMuiTheme()}>
              <Typography className={classes.addUserTitle} variant="h4">
                Add New User
              </Typography>
              <form autoComplete={"off"} className={classes.form}>
                <TextField
                  type="text"
                  className={classes.addUser}
                  label="First Name"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.addUserInput,
                    },
                  }}
                  onChange={(e) => {
                    setUser({ ...user, firstName: e.target.value });
                  }}
                />
                <TextField
                  type="text"
                  className={classes.addUser}
                  label="Last Name"
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.addUserInput,
                    },
                  }}
                  onChange={(e) => {
                    setUser({ ...user, lastName: e.target.value });
                  }}
                />
                <TextField
                  type="text"
                  className={classes.addUser}
                  label="Email Address"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {showEmailValidity ? (
                          emailValid === true ? (
                            <Fade in={emailValid}>
                              <CheckIcon className={classes.fieldIcons} />
                            </Fade>
                          ) : (
                            <Fade in={!emailValid}>
                              <CloseIcon className={classes.fieldIcons} />
                            </Fade>
                          )
                        ) : (
                          ""
                        )}
                      </InputAdornment>
                    ),
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.addUserInput,
                    },
                  }}
                  onChange={(e) => {
                    emailValue(e);
                  }}
                  onFocus={() => {
                    setShowEmailValidity(false);
                  }}
                  onBlur={(e) => {
                    if (e.target.value.length > 0) {
                      setShowEmailValidity(true);
                    } else {
                      setShowEmailValidity(false);
                    }
                  }}
                />
                <TextField
                  type="password"
                  className={classes.addUser}
                  label={`Default Password is "P@55word"`}
                  InputProps={{
                    classes: {
                      underline: classes.textFieldUnderline,
                      input: classes.addUserInput,
                    },
                  }}
                  onChange={(e) => {
                    let error = '';
                    function validate(password) {
                      let minMaxLength = /^[\s\S]{8,32}$/,
                        upper = /[A-Z]/,
                        lower = /[a-z]/,
                        number = /[0-9]/,
                        special = /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;

                      if (minMaxLength.test(password) &&
                        upper.test(password) &&
                        lower.test(password) &&
                        number.test(password) &&
                        special.test(password)
                      ) {
                        return true;
                      }
                      return false;
                    }
                    if (!validate(e.target.value.trim())) {
                      error = 'Password must have at least 8 characters, 1 lower case, 1 upper case and 1 special character.';
                    }
                    setUser({ ...user, password: e.target.value.trim(), error: error });
                  }}
                />
                <Button
                  disabled={
                    user.firstName.length === 0 ||
                    user.lastName.length === 0 ||
                    user.email.length === 0 ||
                    user.password.length === 0 ||
                      user.error !== '' ||
                    emailValid === false
                  }
                  variant="contained"
                  size="large"
                  className={classes.addUserBtn}
                  onClick={handleNewUser}
                >
                  Add User
                </Button>
                {user.error !== '' && (
                  <Fade in={user.error}>
                    <>
                      <div className={classes.errorSection}>
                        <Typography className={classes.errorMessage}>
                          {user.error}
                        </Typography>
                      </div>
                    </>
                  </Fade>
                )}
                {error && (
                  <Fade in={error}>
                    <>
                      <div className={classes.errorSection}>
                        <ReportProblemRoundedIcon
                          className={classes.errorIcon}
                        />
                        <Typography className={classes.errorMessage}>
                          User Addition Failed !!
                        </Typography>
                      </div>
                    </>
                  </Fade>
                )}
              </form>
            </MuiThemeProvider>
          </Card>
        </div>
      </div>
    </>
  );
};

export default AddUser;
